import * as angular from "angular";
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {AgentModel} from "../../angular/models/agent.model";
import {WorkingSlotsService} from "../../../working-slots/services/working-slots-service.service";
import {AgentDialogService} from "../../services/agent-dialogs-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {WorkingSlotEntity} from "../../../working-slots/models/working-slot.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {WorkingSlotsDialogService} from "../../../working-slots/services/working-slots-dialog-service.service";

export class AgentWorkingSlotsCtrl implements IController {

  agent: AgentModel;
  score: any;

  onAssign: Function;

  private loaded: boolean;
  private loadLimit: number;
  private filterConfig: any;
  private workingSlotsRef: any;
  private infiniteScroll: any;
  private zoneId: string;

  constructor(private $log: ILogService,
              private moment,
              private $infiniteScroll,
              private $workingSlots,
              private splitService: SplitService,
              private agentDialogService: AgentDialogService,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService,
              private workingSlotsService: WorkingSlotsService,
              private confirmDialogService: ConfirmDialogService,
              private workingSlotsDialogService: WorkingSlotsDialogService) {
  }

  $onInit() {
    this.zoneId = this.splitService.getTimeZone();
    this.loadLimit = 30;
    this.workingSlotsRef = this.$workingSlots();

    this.loaded = false;
    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.dateRangeTimeFiltersService.today(),
    };

    this.workingSlotsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.workingSlotsRef, this.loadLimit, {getFullData: true});
  }

  onRangeChanged(range) {
    if (!_.isUndefined(range) && !_.isEqual(range.name, this.filterConfig.range.name)) {
      this.filterConfig.range = range;
      this._reloadQuery();
    }
  }

  editRow(workingSlot) {
    this.agentDialogService.editAgentWorkingSlot(workingSlot)
      .then((workingSlot) => {
        this._validateWorkingSlotsAndUpdate(workingSlot);

      })
      .catch((error) => {
        this.$log.debug('Dialog Closed');
      })
  }


  onDeleteWorkingSlot(workingSlot: WorkingSlotEntity, event) {

    const text = 'Are you sure you want to delete this working slot?';
    this.confirmDialogService.confirm('Delete Working Slot', text, event)
      .then(() => {
        this._deleteWorkingSlot(workingSlot.id);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  onCreateNewTimeSlotClicked(event?) {
    this.agentDialogService.createAgentWorkingSlots(event, this.agent.id)
      .then((workingSlots: WorkingSlotEntity[]) => {
        this._validateWorkingSlotsAndCreate(workingSlots);
      })
      .catch(() => {
        this.$log.debug('Dialog Closed');
      })
  }

  private _validateWorkingSlotsAndUpdate(workingSlot: WorkingSlotEntity) {
    this.workingSlotsService.validateWorkingSlots([workingSlot], this.zoneId)
      .then((workingSlotsCollisions: WorkingSlotEntity[]) => {
        if (workingSlotsCollisions && workingSlotsCollisions.length) {
          this._askTheUserIfOverrideWorkingSlotsAndEditOrOpenEditDialog(workingSlot, workingSlotsCollisions);
        } else {
          this._updateWorkingSlot(workingSlot);
        }
      })
  }


  private _validateWorkingSlotsAndCreate(workingSlots: WorkingSlotEntity[]) {
    this.workingSlotsService.validateWorkingSlots(workingSlots, this.zoneId)
      .then((workingSlotsCollisions: WorkingSlotEntity[]) => {
        if (workingSlotsCollisions && workingSlotsCollisions.length) {
          this._askTheUserIfOverrideWorkingSlotsAndCreateOrOpenCreateDialog(workingSlots, workingSlotsCollisions);
        } else {
          this._createWorkingSlot(workingSlots)
        }
      })
  }


  private _askTheUserIfOverrideWorkingSlotsAndEditOrOpenEditDialog(workingSlot: WorkingSlotEntity, workingSlotsCollisions: WorkingSlotEntity[]) {
    this.workingSlotsDialogService.addWorkingSlotAndOverrideExistingWorkingSlots(workingSlotsCollisions)
      .then(() => {
        const workingSlotsCollisionsIds = workingSlotsCollisions.map(ws => ws.id)
        this._updateWorkingSlot(workingSlot, workingSlotsCollisionsIds, true)
      })
      .catch(() => {
        this.editRow(workingSlot);
      })
  }

  private _askTheUserIfOverrideWorkingSlotsAndCreateOrOpenCreateDialog(workingSlots: WorkingSlotEntity[], workingSlotsCollisions: WorkingSlotEntity[]) {
    this.workingSlotsDialogService.addWorkingSlotAndOverrideExistingWorkingSlots(workingSlotsCollisions)
      .then(() => {
        const workingSlotsCollisionsIds = workingSlotsCollisions.map(ws => ws.id)
        this._createWorkingSlot(workingSlots, workingSlotsCollisionsIds, true)
      })
      .catch(() => {
        this.onCreateNewTimeSlotClicked();
      })
  }

  private _updateWorkingSlot(workingSlot: WorkingSlotEntity, overrideIds?: string[], override?: boolean) {
    this.workingSlotsService.updateOne(workingSlot,this.zoneId, overrideIds, override)
      .then(((updatedWorkingSlot) => {
        this._reloadQuery();
      }))
  }

  private _createWorkingSlot(workingSlots: WorkingSlotEntity[], overrideIds?: string[], override?: boolean) {
    this.workingSlotsService.create(workingSlots, this.zoneId, overrideIds, override)
      .then(((updatedWorkingSlot) => {
        this._reloadQuery();
      }))
  }

  private _reloadQuery() {
    this.workingSlotsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      agentId: this.agent.id,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      limit: this.loadLimit
    }
  }

  private _deleteWorkingSlot(workingSlotId) {
    this.workingSlotsService.deleteOne(workingSlotId)
      .then(((deletedWorkingSlot) => {
        this._reloadQuery();
      }))
      .catch((error) => {
        this.$log.debug('Dialog Closed');
      })
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentWorkingSlots', {
    bindings: {
      agent: '<'
    },
    template: require('./agent-working-slots.html').default,
    controller: AgentWorkingSlotsCtrl
  });
